import React, { useEffect, useState } from "react";
import PropertyTable from "./PropertyTable";
import plus from "../../Images/Vector@2x.png";
import "./PropertyList.css";
import "./Pagination.css"; // Import pagination CSS

const PropertyColumn = ({
  propertyData,
  loading,
  showFav,
  activeData,
  showBlurred,
  currentPage,
  totalPages,
  onPageChange,
  handleClick,
}) => {
  console.log("PropertyColumn data:", propertyData);

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // Show max 5 page buttons

    if (totalPages <= maxPagesToShow) {
      // Show all pages if total pages are less than max to show
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show first page, last page, and pages around current page
      const startPage = Math.max(1, currentPage - 2);
      const endPage = Math.min(totalPages, currentPage + 2);

      if (startPage > 1) {
        pageNumbers.push(1);
        if (startPage > 2) {
          pageNumbers.push("...");
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push("...");
        }
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers;
  };

  return (
    <>
      {loading && (
        <div className="property_list_div text-center p-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading properties...</p>
        </div>
      )}

      <div className="property_list_div">
        {propertyData?.length === 0 && !loading ? (
          <div
            className="no_data_message"
            style={{
              color: "black",
              margin: "10px",
              textAlign: "center",
              padding: "20px",
            }}
          >
            <h4>No Property found</h4>
            <p className="text-muted">Try adjusting your search criteria</p>
          </div>
        ) : (
          !loading && (
            <>
              <div className="tabel_wrapper">
                <table>
                  <thead style={{ position: "sticky", zIndex: "99", top: "0" }}>
                    <tr>
                      <th className="table_head_1">Locality</th>
                      <th className="table_head_2">Address</th>
                      <th className="table_head_3">Area</th>
                      <th className="table_head_4">Floor</th>
                      <th className="table_head_5">BHK</th>
                    </tr>
                  </thead>
                  <tbody>
                    <PropertyTable
                      data={propertyData}
                      showFav={showFav}
                      activeData={activeData}
                      showBlurred={showBlurred}
                      handleClick={handleClick}
                    />
                  </tbody>
                </table>
              </div>

              {/* Pagination - Only show if totalPages > 1 */}
              {totalPages > 1 && (
                <div className="pagination-container column-pagination">
                  <div className="pagination">
                    {/* Previous button */}
                    <button
                      className="pagination-button prev"
                      onClick={() => onPageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <i className="fa-solid fa-chevron-left"></i> Previous
                    </button>

                    {/* Page numbers */}
                    <div className="page-numbers">
                      {getPageNumbers().map((page, index) =>
                        page === "..." ? (
                          <span key={`ellipsis-${index}`} className="ellipsis">
                            ...
                          </span>
                        ) : (
                          <button
                            key={page}
                            className={`page-number ${currentPage === page ? "active" : ""}`}
                            onClick={() => onPageChange(page)}
                          >
                            {page}
                          </button>
                        ),
                      )}
                    </div>

                    {/* Next button */}
                    <button
                      className="pagination-button next"
                      onClick={() => onPageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>

                  {/* Showing info */}
                  <div className="pagination-info">
                    Showing page {currentPage} of {totalPages}
                  </div>
                </div>
              )}
            </>
          )
        )}
      </div>
    </>
  );
};

export default PropertyColumn;
